// import components
import { GridColDef } from '@mui/x-data-grid-pro';

// import hooks
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { EndOfEmploymentSettlementResponse } from 'generated/index';

// import utils
import { getRoundedNumericValue } from './useGetColumns.utils';
import dayjs from 'dayjs';

export const useGetColumns = (showPlusMinusHoursReversed: boolean) => {
  const { t } = useTranslation('common');

  return useMemo<GridColDef<EndOfEmploymentSettlementResponse>[]>(
    () => [
      {
        headerName: t('employee'),
        field: 'employment.employeeName',
        type: 'string',
        valueGetter: (_, row) => row?.employment.employeeName,
        flex: 1
      },
      {
        headerName: t('endOfEmploymentSettlement.endOfEmploymentDate'),
        field: 'endOfEmploymentSettlementDate',
        type: 'date',
        headerAlign: 'center',
        align: 'center',
        valueGetter: (_, row) => row?.endOfEmploymentSettlementDate,
        valueFormatter: (params) => {
          return params ? dayjs(params).format('DD-MM-YYYY') : '';
        }
      },
      {
        headerName: t('endOfEmploymentSettlement.extraHours'),
        field: 'extraHours',
        type: 'number',
        headerAlign: 'center',
        align: 'center',
        valueGetter: getRoundedNumericValue(
          'extraHours',
          showPlusMinusHoursReversed
        )
      },
      {
        headerName: t('endOfEmploymentSettlement.leaveHours'),
        field: 'leaveHours',
        type: 'number',
        headerAlign: 'center',
        align: 'center',
        valueGetter: getRoundedNumericValue('leaveHours')
      },
      {
        headerName: t('endOfEmploymentSettlement.plbHours'),
        field: 'plbHours',
        type: 'number',
        headerAlign: 'center',
        align: 'center',
        valueGetter: getRoundedNumericValue('plbHours')
      }
    ],
    [t, showPlusMinusHoursReversed]
  );
};
